import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BottomNav from "@/components/BottomNav";
import Home from "@/pages/Home";
import Archivo from "@/pages/Archivo";
import MensajeDetalle from "@/pages/MensajeDetalle";
import MuroOracion from "@/pages/MuroOracion";
import Favoritos from "@/pages/Favoritos";
import Login from "@/pages/Login";
import Registro from "@/pages/Registro";
import Admin from "@/pages/Admin";
import Cuenta from "@/pages/Cuenta";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <div className="flex min-h-screen flex-col">
            <Header />
            <main className="flex-1 pb-20 md:pb-0">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/archivo" element={<Archivo />} />
                <Route path="/mensaje/:id" element={<MensajeDetalle />} />
                <Route path="/oracion" element={<MuroOracion />} />
                <Route path="/favoritos" element={<Favoritos />} />
                <Route path="/login" element={<Login />} />
                <Route path="/registro" element={<Registro />} />
                <Route path="/cuenta" element={<Cuenta />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
            <BottomNav />
          </div>
          <Toaster position="bottom-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
